import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga'

import moment from 'moment';
import {
  capitalizeWords,
  getFeedIconForFacebook, getFeedIconForInstagram,
  getFeedIconForReddit,
  getFeedIconForYoutube,
  getFeedIconForForum
} from '../sharedFunctions';
import RelevanceCard from './comment-toggle/RelevanceCard';
import SarcasmTogglingCard from './comment-toggle/SarcasmTogglingCard';
import {
  MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB,
  MAX_COMMENT_TEXT_LENGTH_FOR_FEED_MODAL,
  SARCASTIC_PILL_CLASS,
  NOT_SARCASTIC_PILL_CLASS,
  SARCASTIC_LABEL,
  NOT_SARCASTIC_LABEL,
  NO_SPECIFIC_EMOTION_PILL_CLASS,
  NO_SPECIFIC_EMOTION,
  SARCASM_CONFIDENCE_SCORE_HOVER_TEXT,
  SARCASM_MANUALLY_TOGGLED_HOVER_TEXT,
  MARKED_AS_IRRELEVANT_LABEL,
  CRYSTALFEEL_CATEGORIES_TO_ICONS_MAP,
  SARCASM_ICON_FILE_PATH,
  E_PLUS_TWO,
  E_MINUS_TWO
} from '../redux/constants';
import { 
  IS_SARCASM_ENABLED, 
  SARCASM_THRESHOLD_PERCENTAGE,
  CONSTRUCTIVENESS_THRESHOLD,
  MINIMUM_CONSTRUCTIVENESS_SCORE
} from '../../../common/globalConstants';
import {
  FACEBOOK_PAGE_CSS_CLASS_NAME,
  FACEBOOK_PAGE_IN_SOURCE_NAME, INSTAGRAM_KEY,
  REDDIT_KEY,
  YOUTUBE_KEY,
  FORUM_KEY
} from './constants/FeedCommentConstants';
import { 
  HEATED_COMMENTS_ICON_FILE_PATH, 
  HEATED_COMMENT_LABEL,
  TOXIC_COMMENTS_ICON_FILE_PATH,
  TOXIC_COMMENT_LABEL,
  TOXICITY_SCORE_THRESHOLD
} from '../../harmwatch/components/constants';
import { t } from 'i18next';
import { 
  FEED_COMMENTS_I18N_PREFIX as MY_I18N_PREFIX, 
  FEED_COMMENTS_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/FeedCommentsi18nConstants.js';

export class FeedComments extends Component {
  static propTypes = {
    userComment: PropTypes.object.isRequired,
    updateRelevance: PropTypes.func.isRequired,
    updateCrawledCommentsIsSarcasmManuallyToggled: PropTypes.func.isRequired,
    cookies: PropTypes.object,
    isHarmWatchTab: PropTypes.bool.isRequired,
    isFeedModal: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      userComment: {
        comment: "",
        isTranslated:false,
        commentInOriginalLanguage : "",
        source: "",
        sentiment: {
          category: ""
        },
        emotion: {
          category: ""
        },
        sarcasm: {
          score: 0
        }
      },
      maxCommentStringLength: 0,
      isSeeMore: false,
      isEllipsisActive: false
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    const userComment = this.props.userComment; 
    const isFeedModal = this.props.isFeedModal;
    this.setState({
      userComment: userComment,
      maxCommentStringLength: isFeedModal ? MAX_COMMENT_TEXT_LENGTH_FOR_FEED_MODAL : MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      userComment: nextProps.userComment,
      maxCommentStringLength: nextProps.isFeedModal ? MAX_COMMENT_TEXT_LENGTH_FOR_FEED_MODAL : MAX_COMMENT_TEXT_LENGTH_FOR_SIDE_TAB
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getI18nText(textKey,params={}) {
    return t(MY_I18N_PREFIX + "." + textKey,params);
  }

  toggleSeeMore = isSeeMore => {
    if (!this.props.isHarmWatchTab) {
      ReactGA.event(
        {
          category : 'Comments' ,
          action : `User with id ${this.props.cookies.userMeta} was redirected to see more about ${this.props.userComment} from ${this.state.userComment.source}`
        }
      )
    }
    this.setState({isSeeMore});
  }

  _getFeedCommentCSSName = () => {
    const {userComment} = this.state;
    if (userComment.source.toLowerCase().includes(FACEBOOK_PAGE_IN_SOURCE_NAME)) {
      return FACEBOOK_PAGE_CSS_CLASS_NAME;
    }
    else {
      return userComment.source.toLowerCase();
    }
  }

  _getFeedIcon = () => {
    const {userComment} = this.state;
    if (userComment.source.toLowerCase().includes(FACEBOOK_PAGE_IN_SOURCE_NAME)) {
      return getFeedIconForFacebook(userComment.source);
    }
    else if (userComment.source.toLowerCase() == REDDIT_KEY){
      return getFeedIconForReddit(userComment.sourceLink)
    }
    else if (userComment.source.toLowerCase() == YOUTUBE_KEY){
      return getFeedIconForYoutube()
    }
    else if (userComment.source.toLowerCase().includes(INSTAGRAM_KEY)){
      return getFeedIconForInstagram();
    }
    else if (userComment.source.toLowerCase().includes(FORUM_KEY)){
      return getFeedIconForForum(userComment.source);
    }
    else {
      return userComment.source.toLowerCase();
    }
  }

  _returnSarcasmPillClass = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {userComment} = this.state;
    const isSarcasmManuallyToggled = userComment.sarcasm.isSarcasmManuallyToggled;
    const sarcasmScorePercentageFormatRounded = this._returnOutputScoresRoundedToMaximumTwoDecimalPlaces(userComment.sarcasm.score);
    if (sarcasmScorePercentageFormatRounded >= SARCASM_THRESHOLD_PERCENTAGE) {
      if (!isSarcasmManuallyToggled) {
        return SARCASTIC_PILL_CLASS;
      }
      else {
        return NOT_SARCASTIC_PILL_CLASS;
      }
    }
    else if (sarcasmScorePercentageFormatRounded >= 0) {
      if (!isSarcasmManuallyToggled) {
        return NOT_SARCASTIC_PILL_CLASS;
      }
      else {
        return SARCASTIC_PILL_CLASS;
      }
    }
    return '';
  }
  
  _returnSarcasmPillText = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {userComment} = this.state;
    const isSarcasmManuallyToggled = userComment.sarcasm.isSarcasmManuallyToggled;
    const sarcasmScorePercentageFormatRounded = this._returnOutputScoresRoundedToMaximumTwoDecimalPlaces(userComment.sarcasm.score);
    if (sarcasmScorePercentageFormatRounded >= SARCASM_THRESHOLD_PERCENTAGE) {
      if (!isSarcasmManuallyToggled) {
        return `${SARCASTIC_LABEL} (${sarcasmScorePercentageFormatRounded}%)`;
      }
      else {
        return `${NOT_SARCASTIC_LABEL}`;
      }
    }
    else if (sarcasmScorePercentageFormatRounded >= 0) {
      if (!isSarcasmManuallyToggled) {
        return `${NOT_SARCASTIC_LABEL} (${sarcasmScorePercentageFormatRounded}%)`;
      }
      else {
        return `${SARCASTIC_LABEL}`;
      }
    }
    return '';
  }

  _returnSarcasmPillHoverText = () => {
    if (!IS_SARCASM_ENABLED) {
      return '';
    }
    const {userComment} = this.state;
    if (userComment.sarcasm.isSarcasmManuallyToggled) {
      return SARCASM_MANUALLY_TOGGLED_HOVER_TEXT;
    }
    else {
      const sarcasmScorePercentageFormatRounded = this._returnOutputScoresRoundedToMaximumTwoDecimalPlaces(userComment.sarcasm.score);
      return `${SARCASM_CONFIDENCE_SCORE_HOVER_TEXT} ${sarcasmScorePercentageFormatRounded}%`;
    }
  }

  _returnOutputScoresRoundedToMaximumTwoDecimalPlaces = (rawScore) => {
    const outputScorePercentageFormat = rawScore * 100;
    const outputScorePercentageFormatRounded = +(Math.round(parseFloat(outputScorePercentageFormat + E_PLUS_TWO)) + E_MINUS_TWO);
    return outputScorePercentageFormatRounded;
  }

  _returnEmotionPillClass = () => {
    const {userComment} = this.state;
    const userEmotion = userComment.emotion.category
    if (userEmotion === NO_SPECIFIC_EMOTION) {
      return NO_SPECIFIC_EMOTION_PILL_CLASS
    } else {
      return userEmotion
    }
  }

  _returnShouldSarcasmFeaturesBeShown = () => {
    const {userComment} = this.state;
    return (IS_SARCASM_ENABLED && userComment.sarcasm.score >= 0);
  }

  toggleIfEllipsisIsActive= () => {
    this.setState(prevState => {
      return { isEllipsisActive: !prevState.isEllipsisActive };
    });
  
  }

  handleClickOutside = event => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({isEllipsisActive: false });
    }
  }

  updateRelevanceInRelevanceCard = commentId => {
    const { updateRelevance } = this.props;
    updateRelevance(commentId);
    this.setState({
      isEllipsisActive: false
    });
  }

  updateIsSarcasmManuallyToggledInDropdown = commentId => {
    const { updateCrawledCommentsIsSarcasmManuallyToggled } = this.props;
    updateCrawledCommentsIsSarcasmManuallyToggled(commentId);
    this.setState({
      isEllipsisActive: false
    });
  }

  renderOriginalLanguageOfFeedCommentIfItIsTranslated(userComment,isSeeMore,maxCommentStringLength){
    return userComment.isTranslated && (
      <div className='original-non-english'>
      <div className='vertical-line'/>
      <div className="content">
        <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`}>{userComment.commentInOriginalLanguage}</p>
        {userComment.commentInOriginalLanguage.length > maxCommentStringLength && !isSeeMore ? (
          <span className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
            <u>See More</u>
          </span>
        ) : (
          userComment.commentInOriginalLanguage.length > maxCommentStringLength &&
          isSeeMore && (
            <span className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
              See Less
            </span>
          )
        )}
      </div>
    </div>
    )
  }

  returnConstructivenessPill(constructivenessScorePercentageFormatRounded) {
    const { userComment } = this.state;
    return (
      <div className="card-header-button">
        <button 
          className={`btn-emotion ${userComment.constructivenessScore >= CONSTRUCTIVENESS_THRESHOLD ? 'constructive' : 'not-constructive'}`}
          title={this.getI18nText(MY_I18N_KEYS.constructive_hover_text, {constructivenessScore:constructivenessScorePercentageFormatRounded})}
        >
          {
            userComment.constructivenessScore >= CONSTRUCTIVENESS_THRESHOLD ? 
              this.getI18nText(MY_I18N_KEYS.constructive_label, {constructivenessScore:constructivenessScorePercentageFormatRounded}) :
              this.getI18nText(MY_I18N_KEYS.not_constructive_label, {constructivenessScore:constructivenessScorePercentageFormatRounded})
          }
        </button>
      </div>
    );
  }

  returnCardHeaderButtonsForResonanceDashboard() {
    const { userComment }               = this.state;
    const isFeedModal                   = this.props.isFeedModal;
    const feedCommentCSSName            = this._getFeedCommentCSSName();
    const emotionPillClass              = this._returnEmotionPillClass();
    const shouldSarcasmFeaturesBeShown  = this._returnShouldSarcasmFeaturesBeShown();
    const sarcasmPillText        = this._returnSarcasmPillText();
    const sarcasmPillClass       = this._returnSarcasmPillClass();
    const sarcasmPillHoverText   = this._returnSarcasmPillHoverText();

    const constructivenessScorePercentageFormatRounded = this._returnOutputScoresRoundedToMaximumTwoDecimalPlaces(userComment.constructivenessScore);
    
    return (
      <React.Fragment>
        <div
          className={`social-button card-header-button ${feedCommentCSSName}`}
        >
          <span title={`${capitalizeWords(feedCommentCSSName)}`}>
            <img src={this._getFeedIcon()} alt=""/> 
          </span>
        </div>
        <div className='card-pill-column'>
          <div className='card-pill-row'>
            <div className="card-header-button">
              {userComment.sentiment.category && (
                <button className={`btn-positive ${userComment.sentiment.category}`}>
                  {userComment.sentiment.category}
                </button>
              )}
            </div>
            
            {userComment.emotion.category && (
                <div className="card-header-button">
                  {userComment.emotion.category && (
                    <button className={`btn-emotion ${emotionPillClass}`}>
                      {userComment.emotion.category}
                    </button>
                  )}
                </div>
            )}

            <div className="card-header-button">
              {shouldSarcasmFeaturesBeShown &&
                (
                  <button 
                    className={`btn-emotion ${sarcasmPillClass}`}
                    title={sarcasmPillHoverText}
                  >
                    {sarcasmPillText}
                    {userComment.sarcasm.isSarcasmManuallyToggled ? <i className="las la-user-edit icon"></i> : ''}
                  </button>
              )}
            </div>
            {userComment.constructivenessScore >= MINIMUM_CONSTRUCTIVENESS_SCORE && isFeedModal && 
              this.returnConstructivenessPill(constructivenessScorePercentageFormatRounded)
            }
          </div>
          {userComment.constructivenessScore >= MINIMUM_CONSTRUCTIVENESS_SCORE && !isFeedModal && (
            <div className='card-pill-row second-row'> 
              {this.returnConstructivenessPill(constructivenessScorePercentageFormatRounded)}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
  returnCardHeaderButtonsForHarmWatchTab() {
    const { userComment } = this.state;
    const emotionPillClass              = this._returnEmotionPillClass();
    const shouldSarcasmFeaturesBeShown  = this._returnShouldSarcasmFeaturesBeShown();
    const sarcasmPillText               = this._returnSarcasmPillText();
    const sarcasmPillClass              = this._returnSarcasmPillClass();
    const sarcasmPillHoverText          = this._returnSarcasmPillHoverText();
    
    return (
      <React.Fragment>
        {userComment.toxicityScore >= TOXICITY_SCORE_THRESHOLD && (
          <div className="card-header-button">
            <div 
              className={"harm-watch-index-pill"}
              title={TOXIC_COMMENT_LABEL}
            >
              <img
                src={TOXIC_COMMENTS_ICON_FILE_PATH}
                alt={TOXIC_COMMENT_LABEL}
              />
            </div>
          </div>
        )}
        {userComment.isEmotionallyHeated && (
          <div className="card-header-button">
            <div 
              className={"harm-watch-index-pill"}
              title={HEATED_COMMENT_LABEL}
            >
              <img
                src={HEATED_COMMENTS_ICON_FILE_PATH}
                alt={HEATED_COMMENT_LABEL}
              />
            </div>
          </div>
        )}
        {userComment.sentiment.category && (
          <div className="card-header-button harm-watch-header-button">
            <button className={`btn-harm-watch-modal ${userComment.sentiment.category}`}>
              <img
                src={CRYSTALFEEL_CATEGORIES_TO_ICONS_MAP[userComment.sentiment.category]}
                alt={userComment.sentiment.category}
              />
              <label>{userComment.sentiment.category}</label> 
            </button>
          </div>
        )}
        {userComment.emotion.category && (
            <div className="card-header-button harm-watch-header-button">
              <button className={`btn-harm-watch-modal ${emotionPillClass}`}>
                <img
                  src={CRYSTALFEEL_CATEGORIES_TO_ICONS_MAP[userComment.emotion.category]}
                  alt={userComment.emotion.category}
                />
                <label>{userComment.emotion.category}</label> 
              </button>
            </div>
          )}
        {shouldSarcasmFeaturesBeShown && (
          <div className="card-header-button harm-watch-header-button">
            <button 
              className={`btn-harm-watch-modal ${sarcasmPillClass}`}
              title={sarcasmPillHoverText}
            >
              <img
                src={SARCASM_ICON_FILE_PATH}
                alt={sarcasmPillText}
              />
              <label>
                {sarcasmPillText}
                {userComment.sarcasm.isSarcasmManuallyToggled ? <i className="las la-user-edit icon"></i> : ''}
              </label>
            </button>
          </div>
        )}
      </React.Fragment>
    );
  }

  render() {
    const { 
      userComment,
      isSeeMore,
      maxCommentStringLength,
      isEllipsisActive
    } = this.state;
    const shouldSarcasmFeaturesBeShown  = this._returnShouldSarcasmFeaturesBeShown();
    return (
        <div className={`comment-card ${this.props.isHarmWatchTab ? 'harm-watch-modal' : ''}`}>
          <div className="header">
            <div
              className="category"
              ref={this.wrapperRef}
            >
              {this.props.isHarmWatchTab ? this.returnCardHeaderButtonsForHarmWatchTab() : this.returnCardHeaderButtonsForResonanceDashboard()}
              <div 
                className={`ellipsis ${isEllipsisActive ? 'active' : ''}`}
                onClick={() => this.toggleIfEllipsisIsActive()} 
              >
                <i className="la la-ellipsis-v"></i>
              </div>
              {isEllipsisActive && (
                <div className="comments-toggle default-toggle-card-margin">
                  {!this.props.isHarmWatchTab && (<RelevanceCard
                    userCommentOrPost={this.props.userComment}
                    updateRelevance={e => this.updateRelevanceInRelevanceCard(e)}
                    commentOrPostId={this.props.userComment.commentId}
                    isRelevanceButtonDisabled={!this.props.userComment.postRelevance}
                  />)}
                  {shouldSarcasmFeaturesBeShown && (
                    <SarcasmTogglingCard
                      userComment={this.props.userComment}
                      updateIsSarcasmManuallyToggled={e => this.updateIsSarcasmManuallyToggledInDropdown(e)}
                      commentId={String(this.props.userComment.commentId)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="content">
            <p className={`${!isSeeMore ? 'shrink-text-view' : ''}`}>{userComment.comment}</p>
            {userComment.comment.length > maxCommentStringLength && !isSeeMore ? (
              <span className="see-more-btn" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                <u>See More</u>
              </span>
            ) : (
              userComment.comment.length > maxCommentStringLength &&
              isSeeMore && (
                <span className="see-more-btn less" onClick={() => this.toggleSeeMore(!isSeeMore)}>
                  See Less
                </span>
              )
            )}
          </div>
          {this.renderOriginalLanguageOfFeedCommentIfItIsTranslated(userComment,isSeeMore,maxCommentStringLength)}
          <div className={`card-header-bottom ${!userComment.relevance ? 'card-header-bottom-space-between' : ''}`}>
            {!userComment.relevance && (
              <div className="card-header-irrelevant">{MARKED_AS_IRRELEVANT_LABEL}</div>
            )}
            <label>{moment(userComment.datetime).format('DD MMM YYYY hh:mm A')}</label>
          </div>
        </div>
      )
  }
}

export default FeedComments;



// WEBPACK FOOTER //
// ./src/features/home/components/feed-comments.js